/**
 * Служебное имя метрики за второй период сравнения.
 *
 * Раньше к имени метрики приписывался '_2', но этот суффикс уже занят —
 * он обозначает принадлежность метрики к отчёту по заказам
 * (orders_count — «Заказы» в отчёте по регистрациям, orders_count_2 — «Заказы»
 * в отчёте по заказам, см. REPORT_SUFFIXES в helpers/utils/reports.tsx).
 * Из-за совпадения имён сервер считал для второго периода не ту метрику.
 *
 * Суффикс должен оставаться таким, которого нет в справочнике метрик,
 * и совпадать с FilterController::COMPARE_METRIC_SUFFIX на бэкенде.
 */
export const COMPARE_METRIC_SUFFIX = '__cmp';

/** Является ли ключ метрики служебным ключом второго периода сравнения */
export const isCompareMetricKey = (dataKey?: string | null): boolean =>
  Boolean(dataKey) && String(dataKey).endsWith(COMPARE_METRIC_SUFFIX);

/** Имя метрики за второй период сравнения: 'orders_count' → 'orders_count__cmp' */
export const toCompareMetricKey = (dataKey: string): string =>
  `${dataKey}${COMPARE_METRIC_SUFFIX}`;

/** Обратное преобразование: 'orders_count__cmp' → 'orders_count' */
export const toBaseMetricKey = (dataKey: string): string =>
  isCompareMetricKey(dataKey)
    ? dataKey.slice(0, -COMPARE_METRIC_SUFFIX.length)
    : dataKey;

/**
 * Имя второго периода в старом формате — как его отдаёт бэкенд до обновления.
 * Нужно, пока сервер и фронтенд не обновлены одновременно: 'orders_count' → 'orders_count_2'.
 * Для метрик школы (имена вида '_37_') старый бэкенд склеивал подчёркивания: '_37_' → '_37_2'.
 */
export const toLegacyCompareMetricKey = (dataKey: string): string => {
  const base = toBaseMetricKey(dataKey);
  return `${base.startsWith('_') && base.endsWith('_') ? base.slice(0, -1) : base}_2`;
};
